import { render, staticRenderFns } from "./PushNotificationsToolbar.vue?vue&type=template&id=5212a2da&"
import script from "./PushNotificationsToolbar.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationsToolbar.vue?vue&type=style&index=0&id=5212a2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports